import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { useStore } from "@/store";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeModel } from "@/models/nodes/types";

/**
 * The document that resolves a computed node's state and R-label. A hint preview renders from a
 * scratch document, so it resolves against the open one; everywhere else a node keeps its own.
 */
export function useComputedDoc(node: NodeModel): DocumentModel {
  const { doc: openDoc } = useStore();
  const { renderContext } = useNodeStyle();

  return (renderContext === "suggestion" && openDoc) || node.doc;
}
